import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";

// services
import {CarsService} from "../../../shared/services/cars.service";

// models
import {Car} from "../../../shared/models/cars/car";

// modals
import {CarCompletedModalComponent} from "../car-completed-modal/car-completed-modal.component";


@Component({
    selector: 'app-car-show',
    templateUrl: './car-show.component.html',
    styleUrl: './car-show.component.scss'
})
export class CarShowComponent implements OnInit {

    public isLoading = false;
    public carID = 0;
    public car!: Car;

    constructor(private carsService: CarsService,
                private route: ActivatedRoute,
                private router: Router,
                private dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.carID = Number(this.route.snapshot.paramMap.get('id'));
        this.getCarData(this.carID);
    }

    public editCar(): void {
        this.router.navigateByUrl(`secure/car-update/${this.carID}`).then();
    }

    public completed(): void {
        this.dialog.open(CarCompletedModalComponent, {
            data: {
                carID: this.carID
            }
        }).afterClosed().subscribe(
            (res): void => {
                if (!res) {
                    this.router.navigateByUrl(`/secure/cars`).then();
                }
            }
        );
    }

    public back(): void {
        if (this.car.status) {
            this.router.navigateByUrl(`/secure/cars-archive`).then();
        } else this.router.navigateByUrl(`/secure/cars`).then();
    }

    private getCarData(id: number): void {
        this.isLoading = true;
        this.carsService.getCar(id).subscribe((car: Car): void => {
            this.car = car;
            this.isLoading = false;
        })
    }
}
